import { render, staticRenderFns } from "./BookingStatistics.vue?vue&type=template&id=713a0e6d"
import script from "./BookingStatistics.vue?vue&type=script&lang=js"
export * from "./BookingStatistics.vue?vue&type=script&lang=js"
import style0 from "./BookingStatistics.vue?vue&type=style&index=0&id=713a0e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports